/**
 * This file is part of Passager Password Manager.
 * https://github.com/oegea/passager-password-manager
 *
 * Copyright (C) 2022 Oriol Egea Carvajal
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export class RemoveSharedEmailService {
    constructor({
        repository,
        getUserPublicDetailsService,
        userOperationRequest,
    }) {
        this._repository = repository;
        this._getUserPublicDetailsService = getUserPublicDetailsService;
        this._userOperationRequest = userOperationRequest;
    }

    async execute({ folderShareRequest }) {
        const email = folderShareRequest.getEmail();
        const emailList = folderShareRequest.getEmailList();

        // Remove e-mail from emailList
        const index = emailList.indexOf(email);
        if (index > -1) {
            emailList.splice(index, 1);
        }

        folderShareRequest.setEmailList(emailList);

        // Save the new email list updating the folder
        await this._repository.updateFolderSharedWith({ folderShareRequest });

        // Gets the user public details
        const userOperationRequest = this._userOperationRequest({ email });
        const userPublicDetails =
            await this._getUserPublicDetailsService.execute({
                userOperationRequest,
            });

        if (userPublicDetails === null) return false;

        await this._repository.unshareFolder({
            folderShareRequest,
            userPublicDetails,
        });

        return true;
    }
}
